import { Channel } from 'spyne';
import { ChannelFullscreenTraits } from 'traits/channel/channel-fullscreen-traits.js';

export class ChannelFullscreen extends Channel {
  constructor(name, props = {}) {
    name = 'CHANNEL_FULLSCREEN';
    props.traits = [ChannelFullscreenTraits];
    // No replay: ENTER and EXIT are requests to act, and a replayed request
    // would ask the browser for fullscreen with no click behind it. Every
    // consumer is app-lifetime and subscribes before the first change.
    props.replay = false;
    super(name, props);
    this.props.isFullscreen = false;
  }

  onRegistered() {
    this.channelFullscreen$OnRegistered();
  }

  addRegisteredActions() {
    return [
      'CHANNEL_FULLSCREEN_ENTER_EVENT',
      'CHANNEL_FULLSCREEN_EXIT_EVENT',
      'CHANNEL_FULLSCREEN_CHANGE_EVENT',
      ['CHANNEL_FULLSCREEN_STATE_REQUEST', 'channelFullscreen$OnStateRequest'],
    ];
  }
}
